import { defineSlotRecipe } from '@chakra-ui/react';

export const guestsPickerSlotRecipe = defineSlotRecipe({
    slots: ['icon', 'button'],
    base: {
        button: {
            colorPalette: 'secondary',
            flexGrow: 1,
        },
        icon: {
            color: 'secondary.600',
        },
    },
});
